import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { paymentMethodsFormAction, typeOpenSettingsFormAction } from "../../redux/rootReducer";
import { updatePaymentMethodThunk } from "../../redux/thunks/updatePaymentMethodThunk";

const PaymentMethodsForm = () => {
    const dispatch = useDispatch();
    const establishmentList = useSelector(state => state.establishmentList);
    const payment_methods_form = useSelector(state => state.payment_methods_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close"
                            onClick={ () => dispatch(typeOpenSettingsFormAction('')) }
                        />
                        <div className="form__title">Метод оплаты</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Название метода</div>
                        <input type="text" className="input"
                               value={ payment_methods_form.name }
                               onInput={ event => dispatch(paymentMethodsFormAction({
                                   ...payment_methods_form,
                                   name: event.target.value
                               })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="checkbox__wrapper" onClick={ () => {
                            dispatch(paymentMethodsFormAction({
                                ...payment_methods_form,
                                active: payment_methods_form.active === 0 ? 1 : 0
                            }));
                        } }>
                            <div className={ `checkbox ${ payment_methods_form.active === 1 ? 'checkbox--active' : '' }` }/>
                            <div className="checkbox__caption">Активен</div>
                        </div>
                    </div>
                    <div className="form__field">
                        <div className="checkbox__wrapper" onClick={ () => {
                            dispatch(paymentMethodsFormAction({
                                ...payment_methods_form,
                                online: payment_methods_form.online === 0 ? 1 : 0
                            }));
                        } }>
                            <div className={ `checkbox ${ payment_methods_form.online === 1 ? 'checkbox--active' : '' }` }/>
                            <div className="checkbox__caption">Онлайн оплата</div>
                        </div>
                    </div>
                    <div className="form__field">
                        <div className="checkbox__wrapper" onClick={ () => {
                            dispatch(paymentMethodsFormAction({
                                ...payment_methods_form,
                                deposit: payment_methods_form.deposit === 0 ? 1 : 0
                            }));
                        } }>
                            <div className={ `checkbox ${ payment_methods_form.deposit === 1 ? 'checkbox--active' : '' }` }/>
                            <div className="checkbox__caption">Депозит</div>
                        </div>
                    </div>
                    <div className="form__field">
                        <div className="checkbox__wrapper" onClick={ () => {
                            dispatch(paymentMethodsFormAction({
                                ...payment_methods_form,
                                debt: payment_methods_form.debt === 0 ? 1 : 0
                            }));
                        } }>
                            <div className={ `checkbox ${ payment_methods_form.debt === 1 ? 'checkbox--active' : '' }` }/>
                            <div className="checkbox__caption">Долг</div>
                        </div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required" style={{ marginBottom: '10px' }}>Для каких заведений</div>
                        {
                            establishmentList.map(elem => {
                                return (
                                    <div style={{ marginBottom: '10px' }} key={ elem.id }>
                                        <div className="checkbox__wrapper" onClick={ () => {
                                            // Старый массив с заведениями
                                            let est = [...payment_methods_form.establishments];
                                            // Ищем индекс выбранного элемента
                                            let findIndex = est.findIndex(el => el === elem.id);
                                            // Если в массиве есть выбранный элемент, удаляем его
                                            if (findIndex + 1) {
                                                est.splice(findIndex, 1);
                                            }
                                            else {
                                                est.push(elem.id);
                                            }

                                            dispatch(paymentMethodsFormAction({
                                                ...payment_methods_form,
                                                establishments: est
                                            }));

                                        } }>
                                            <div className={ `checkbox ${ payment_methods_form.establishments.includes(elem.id) ? 'checkbox--active' : '' }` }/>
                                            <div className="checkbox__caption">{ elem.name }</div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="form__field">
                        <div className="button"
                             onClick={ () => {
                                 dispatch(updatePaymentMethodThunk({
                                     payment_methods_id: payment_methods_form.id,
                                     name: payment_methods_form.name,
                                     active: payment_methods_form.active,
                                     online: payment_methods_form.online,
                                     deposit: payment_methods_form.deposit,
                                     debt: payment_methods_form.debt,
                                     establishments: JSON.stringify(payment_methods_form.establishments)
                                 }));
                             } }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentMethodsForm;